import BaseModel from './BaseModel';
import RemainingRelevantAnalysisItemDto from './RemainingRelevantAnalysisItemDto';

export default class RemainingRelevantAnalysisDto extends BaseModel {
  constructor(data = {}) {
    super(RemainingRelevantAnalysisDto, data);
    this.awaitingYou =
      data.awaitingYou &&
      new RemainingRelevantAnalysisItemDto(data.awaitingYou);
    this.total =
      data.total && new RemainingRelevantAnalysisItemDto(data.total);
  }
}
